export default "__VITE_ASSET__Cfywj_sr__"